<template>
  <wow-card :title="`WOW Kit Place Order Summary`" :screenType="`wowKitOrderingSummary`" :btnText="`Back`"
    :icon="`mdi-chevron-left`" :btnColor="`#f5f5f5`" outlined :WOWKIT_MAKER='WOWKIT_MAKER' @click="goToWowKitOrderList">
    <v-row no-gutters>
      <v-col class="px-2" cols="12" md="12" lg="12">
        <v-img width="120" class="mb-5" src="https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg"></v-img>
      </v-col>
      <v-col cols="12" md="6" lg="6" class="px-2">
        <wow-card :title="`Billing Address`" :screenType="`wowKitOrderingSummary`" outlined height="400" class="pt-4"
          v-if="franchisee">
          <v-simple-table class="custom-simple-table" dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th id="franchiseeName">Franchisee Name :</th>
                  <td>{{ franchisee.companyName || '-' }}</td>
                </tr>
                <tr>
                  <th id="trustName">Trust Name :</th>
                  <td>{{ franchisee ? franchisee.trustName : '-' }}</td>
                </tr>
                <tr>
                  <th id="address">Address :</th>
                  <td>
                    <span>{{ franchisee ? `${franchisee.address1} ${franchisee.city} ${franchisee.state} ` : '-' }}</span>
                    <span>&nbsp;{{ franchisee ? franchisee.country : '-' }} -{{ franchisee ? franchisee.pincode : '-'
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <th id="gstNo">GST No :</th>
                  <td>{{ franchisee ? franchisee.gstNo : '-' }}</td>
                </tr>
                <tr>
                  <th id="contactPerson">Contact Person :</th>
                  <td>
                    <span>{{ franchisee ? franchisee.firstname : '-' }}</span> &nbsp;
                    <span>{{ franchisee ? franchisee.lastname : '-' }}</span>
                  </td>
                </tr>
                <tr>
                  <th id="mobileNo">Mobile No :</th>
                  <td>
                    <span>{{ franchisee ? franchisee.mobileno : '-' }}</span>
                  </td>
                </tr>
                <tr>
                  <th id="emailId">Email id :</th>
                  <td>{{ franchisee ? franchisee.email : '-' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </wow-card>
      </v-col>
      <v-col cols="12" md="6" lg="6" class="px-2">
        <wow-card :showTitle="false" outlined height="400">
          <wow-card v-if="franchisee" :title="`${franchisee.companyName || ''}  ${franchisee.WareHouseName || ''}`"
            :screenType="`wowKitOrderingSummary`" elevation="0">
            <v-simple-table class="custom-simple-table" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th id="franchiseeGSTNo">GST No :</th>
                    <td>{{ franchisee.gstNo }}</td>
                  </tr>
                  <tr>
                    <th id="franchiseeContactNo">Contact No.</th>
                    <td>{{ franchisee.mobileno }}</td>
                  </tr>
                  <tr>
                    <th id="franchiseeAddress">Address :</th>
                    <td>
                      {{ franchisee.address1 }} ${{ franchisee.city }} {{ franchisee.state }}{{ franchisee.country }}-{{
                        franchisee.pincode }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </wow-card>
          <wow-card class="mt-2" :title="`Shipping Address`" :screenType="`wowKitOrderingSummary`" elevation="0"
            v-if="franchisee">
            <v-simple-table class="custom-simple-table" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th id="shipTo">Ship to :</th>
                    <td>{{ franchisee.firstname }} {{ franchisee.lastname || '' }}</td>
                  </tr>
                  <tr>
                    <th id="shipContactNo">Contact No.</th>
                    <td>{{ franchisee.mobileno || '-' }}</td>
                  </tr>
                  <tr>
                    <th id="shipAddress">Address :</th>
                    <td>
                      {{ franchisee ? `${franchisee.address1} ${franchisee.city} ${franchisee.state} ` : '-' }}
                      &nbsp;{{ franchisee ? franchisee.country : '-' }} -{{ franchisee ? franchisee.pincode : '-' }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </wow-card>
        </wow-card>
      </v-col>
      <v-col cols="12" md="12" lg="12" class="px-2 pt-2">
        <wow-card :showTitle="false" outlined>
          <v-data-table dense hide-default-footer :headers="headers" :items="productItem">
            <template v-slot:body.append>
              <tr>
                <td colspan="5"></td>
                <td class="font-weight-bold">Totals</td>
                <td>{{ totalAmount }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-card-actions class="d-flex justify-end">
            <v-btn dense small color="pink white--text" elevation="1" @click="placeOrder()">
              Confirm & Place order
              <v-icon right>mdi-shopping-music</v-icon>
            </v-btn>
          </v-card-actions>
        </wow-card>
      </v-col>
    </v-row>
  </wow-card>
</template>
<script>
import Utils from '@/utils'
import CONSTANTS from '@/utils/constants'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import _ from 'lodash'
import store from '../../../store/index'
export default {
  name: 'wowKitOrderSummary',
  props: {
    initiatedOrderID: {
      type: String,
      default: null
    },
    franchiseeId: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    WowCard
  },
  data () {
    return {
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER'),
      franchisee: null,
      GSTType: 'IGST',
      totalAmount: 0,
      headers: [
        { text: 'productID', sortable: true, value: 'productID' },
        { text: 'Particulars / HSN', sortable: true, value: 'HSNCode' },
        { text: 'MRP', sortable: true, value: 'mrp' },
        { text: 'Quantity', sortable: true, value: 'quantity' },
        { text: 'IGST (%)', sortable: true, value: 'gst' },
        { text: 'Discount (₹)', sortable: true, value: 'discount' },
        { text: 'Total (incL Tax)(₹)', sortable: true, value: 'totalPrice' }
      ],
      productItem: [],
      initiatedOrderDetails: []
    }
  },
  async created () {
    await this.getFranchisee()
    await this.getInitiatedOrderSummary()
  },
  methods: {
    getFranchisee: async function () {
      try {
        const { data } = await http.get(`${CONSTANTS.API_URL}/api/franchisee/${parseInt(this.franchiseeId)}`)
        this.franchisee = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    goToWowKitOrderList: function () {
      this.$router.push({ name: 'wowKitOrdering' })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getInitiatedOrderSummary: async function () {
      try {
        store.commit('LOADER', true)
        let res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/get-order-amount-b2b?InitatedOrdersID=${this.initiatedOrderID}`)
        if (res.status === 200) {
          this.initiatedOrderDetails = res.data

          res.data.forEach(arrayItem => {
            if (!_.isArray(arrayItem)) {
              return this.$dialog.error({
                text: arrayItem.output.payload.message,
                title: arrayItem.output.payload.error
              })
            } else {
              arrayItem.forEach(item => {
                this.totalAmount = Number(this.totalAmount) + Number(item.amountOrder)
                this.totalAmount = Number(this.totalAmount).toFixed(2)
                item.orderPo.purchaseDetail.forEach(product => {
                  let productData = {}
                  productData.productID = product.id
                  productData.HSNCode = `${product.productDetail.name} (${product.HSNCode})`
                  productData.actualPrice = product.pricing.actualPrice.toFixed(2)
                  productData.quantity = product.quantity
                  productData.discount = product.pricing.discount.toFixed(2)
                  productData.mrp = product.pricing.mrp
                  productData.totalPrice = product.totalPrice.toFixed(2)
                  productData.orderedQuantity = product.orderedQuantity
                  productData.gst = '-'
                  this.GSTType = product.GSTType
                  productData.GSTType = product.GSTType
                  if (product.GSTType) {
                    if (_.isEqual(product.GSTType, 'IGST')) {
                      productData.gst = `${product.IGST} (${product.GSTType})`
                    } else {
                      productData.gst = `${product.CGST}+${product.SGST} (${product.GSTType})`
                    }
                  }
                  productData.sgst = `${product.SGST}`
                  productData.cgst = `${product.CGST}`
                  this.productItem.push(productData)
                })
              })
            }
          })
          this.headers = this.updateHeaders()
          store.commit('LOADER', false)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        store.commit('LOADER', false)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    updateHeaders: function () {
      if (this.productItem.length && _.isEqual(this.GSTType, 'IGST')) {
        return [
          { text: 'productID.', value: 'productID' },
          { text: 'Particulars / HSN.', value: 'HSNCode' },
          { text: 'MRP', value: 'mrp' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'IGST (%)', value: 'gst' },
          { text: 'Discount (₹)', value: 'discount' },
          { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }
        ]
      } else {
        return [
          { text: 'productID.', value: 'productID' },
          { text: 'Particulars / HSN.', value: 'HSNCode' },
          { text: 'MRP', value: 'mrp' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'CGST (%)', value: 'cgst' },
          { text: 'SGST (%)', value: 'sgst' },
          { text: 'Discount (₹)', value: 'discount' },
          { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }
        ]
      }
    },
    placeOrder: function () {
      this.$dialog.confirm({
        title: 'Place Order',
        text: 'Are you sure you want to place this order?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let payload = {}
                payload.wowKitOrders = []
                this.initiatedOrderDetails.forEach(itemArray => {
                  let wowKitOrdersArray = {}
                  wowKitOrdersArray.franchiseeID = parseInt(this.franchiseeId)
                  wowKitOrdersArray.InitatedOrdersID = this.initiatedOrderID
                  wowKitOrdersArray.products = []
                  itemArray.forEach(productItem => {
                    productItem.orderPo.purchaseDetail.forEach(productItemObj => {
                      wowKitOrdersArray.products.push({ quantity: productItemObj.orderedQuantity, productID: productItemObj.id })
                    })
                  })
                  payload.wowKitOrders.push(wowKitOrdersArray)
                })
                let multiOrderId = []
                const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/place-wow-kit-order`, payload)
                if (res.status === 200) {
                  res.data.forEach(itemArray => {
                    itemArray.forEach(obj => {
                      multiOrderId.push(obj.orderID)
                    })
                  })
                }
                this.$router.push({
                  name: 'wowKitOrderConfirmation',
                  params: {
                    franchiseeID: this.franchiseeId,
                    orderID: multiOrderId
                  }
                })
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style>
.custom-card-title {
  color: rgba(0, 0, 0, .87);
}

.custom-simple-table div table {
  border: solid 1px #e4e4e4;
}

.custom-simple-table div table tbody tr th {
  border-right: solid 1px #e4e4e4;
}

.custom-simple-table div table tbody tr td {
  border: none;
}

.custom-simple-table div table tbody tr td:last-child {
  border: none;
}
</style>
